import React from 'react';
import { SharedExaminationPageLayout } from 'pages/Shared/SharedExaminationPage/components/SharedExaminationPageLayout';
import {
  ExaminationPageHeader,
  ExaminationPageInfoBarSkeleton,
  ExaminationPageOverviewSkeleton,
  ExaminationPageInfoBarOuterContainer,
} from '@higo/common/lib/features/ExaminationPage/components';

export const SharedExaminationPageSkeleton = () => (
  <ExaminationPageHeader shadowless>
    <SharedExaminationPageLayout>
      <ExaminationPageOverviewSkeleton />
    </SharedExaminationPageLayout>
    <ExaminationPageInfoBarOuterContainer>
      <SharedExaminationPageLayout>
        <ExaminationPageInfoBarSkeleton />
      </SharedExaminationPageLayout>
    </ExaminationPageInfoBarOuterContainer>
  </ExaminationPageHeader>
);
